import Terraviahome1 from '../../Media/homeimages/Teravia Adora Prime.webp'
import Terraviahome2 from '../../Media/homeimages/Teravia Adora Prime.webp'





const Terraviahomeimages =[
Terraviahome1,Terraviahome2
]

export default Terraviahomeimages;